import CirgsFileCard from './CirgsFileCard';

export default CirgsFileCard;
